import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORM_URL } from 'app/@common/constants'

export default function SelectLocation({...props}) {

    const myProps = {
        urlAjax: FORM_URL.LOCATION,
        placeholder: i18n.t('common:filters.location'),
        icon: {icon: 'map-marker'},
        isMulti: false,
        extraParams: {
            ...props.province && { province: props.province },
        },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
